import React from 'react';
import { withAuthorization } from '../Session';
import { Container, Row, Col, Button, View } from 'react-bootstrap';
import Tabs from 'react-bootstrap/Tabs';
import Tab from 'react-bootstrap/Tab';
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';

import Carousel from 'react-bootstrap/Carousel';
import HomeIcon from '@material-ui/icons/Home';
import PlayArrowIcon from '@material-ui/icons/PlayArrow';
import PlayCircleFilledWhiteIcon from '@material-ui/icons/PlayCircleFilledWhite';
import './styles.css';
import EditCarousel from '../EditCarousel';
import Spinner from 'react-bootstrap/Spinner';
import RestServices from '../services/RestServices.js';

class Tranining extends React.Component {
    _isMounted = false;
    state = {
        isLoading: false,
        isDataLoaded: false,
        isVideoVisible: false,
        videoLanguageList: [],
        videosList: [],
        routesList: [],
        videoLanguage: '',
        selectVideoCat: '',
        videoURL: '',
        alert: 0,
        alertMessage: ''
    };

    componentWillUnmount() {
        this._isMounted = false;
    }

    async componentDidMount() {
        this._isMounted = true;
        this.loadData();
    }

    async loadData() {
        if (this._isMounted) {
            this.setState({ showLoading: true });
        }

        await RestServices.getVideosLanguages(
            localStorage.getItem('FirebaseToken')
        )
            .then((response) => response.json())
            .then((responseData) => {
                if (responseData.error) {
                    if (this._isMounted) {
                        this.setState({
                            showLoading: false,
                            alert: 1,
                            alertMessage: responseData.error
                        });
                    }
                } else {
                    
                    if (this._isMounted) {
                        this.setState({
                            videoLanguageList: responseData,
                            showLoading: false,
                            alert: 0,
                            alertMessage: ''
                        });
                    }
                }
            })
            .catch((err) => {
                if (this._isMounted) {
                    this.setState({
                        showLoading: false,
                        alert: 1,
                        alertMessage: err.message
                    });
                }
            });
    }

    async getVideoByLanguage(selectedLanguage) {
        if (selectedLanguage) {
            this.setState({ showLoading: true });
            this.setState({
                videoLanguage: selectedLanguage.value,
                selectVideoCat: ''
            });
            await RestServices.getVideoLinks(
                localStorage.getItem('FirebaseToken'),
                selectedLanguage.value
            )
                .then((response) => response.json())
                .then((responseData) => {
                    if (responseData.error) {
                        if (this._isMounted) {
                            this.setState({
                                showLoading: false,
                                alert: 1,
                                alertMessage: responseData.error
                            });
                        }
                    } else {
                        

                        let routes = [];
                        Object.keys(responseData).forEach((key) => {
                            routes.push(key);
                        });
                        if (this._isMounted) {
                            this.setState({
                                routesList: routes,
                                videosList: responseData,
                                showLoading: false,
                                alert: 0,
                                alertMessage: ''
                            });
                        }
                    }
                })
                .catch((err) => {
                    if (this._isMounted) {
                        this.setState({
                            showLoading: false,
                            alert: 1,
                            alertMessage: err.message
                        });
                    }
                });
        } else {
            if (this._isMounted) {
                this.setState({ videoLanguage: '' });
            }
        }
    }

    updateVideoCat(newValue) {
        if (this._isMounted) {
            this.setState({ selectVideoCat: newValue ? newValue : '' });
        }
    }

    showVideo(VideoUrl) {
        
        if (this._isMounted) {
            this.setState({ isVideoVisible: true, videoURL: VideoUrl });
        }
    }

    hideVideo() {
        if (this._isMounted) {
            this.setState({ videoURL: '', isVideoVisible: false });
        }
    }

    render() {
        let options = this.state.videoLanguageList;
        let videosList = this.state.videosList;
        let routesList = this.state.routesList;
        const videoLanguage = this.state.videoLanguage;
        const selectVideoCat = this.state.selectVideoCat;

        return (
            <Container>
                {this.state.showLoading && <Spinner animation="border" />}
                <Row>
                    <Col>
                        <h4>Tranining Videos</h4>
                        <hr />
                    </Col>
                </Row>

                {this.state.videoLanguageList && (
                    <Row>
                        <Col xs={4}>
                            <label>Select Language</label>
                            <Autocomplete
                                name="Select Language"
                                onChange={(event, newValue) => {
                                    this.getVideoByLanguage(newValue);
                                }}
                                id="language_filter"
                                options={options}
                                renderOption={(option) => option.label}
                                getOptionLabel={(option) => option.label}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        margin="dense"
                                        variant="outlined"
                                    />
                                )}
                            />
                        </Col>

                        {this.state.routesList != '' &&
                            this.state.videoLanguage && (
                                <Col xs={4}>
                                    <label>Select Category</label>
                                    <Autocomplete
                                        name="Select Category"
                                        value={selectVideoCat}
                                        onChange={(event, newValue) => {
                                            this.updateVideoCat(newValue);
                                        }}
                                        id="vidcat_filter"
                                        options={routesList.map((arr) => arr)}
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                margin="dense"
                                                variant="outlined"
                                            />
                                        )}
                                    />
                                </Col>
                            )}
                    </Row>
                )}

                {this.state.selectVideoCat != '' && (
                    <div>
                        <Row>
                            <Col>
                                <hr />
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <h5>
                                    Training videos form{' '}
                                    {this.state.selectVideoCat}
                                </h5>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <hr />
                            </Col>
                        </Row>
                        <Row>
                            {Object.keys(
                                videosList[this.state.selectVideoCat.toString()]
                            ).map((item) => {
                                let videoData =
                                    videosList[
                                        this.state.selectVideoCat.toString()
                                    ][item];
                                return (
                                    <Col xs={4} key={'video_cat_' + item}>
                                        <div className="product_box">
                                            <p>
                                                <b>{videoData.VideoName}</b>
                                            </p>
                                            <p>{videoData.Description}</p>
                                            <p className="link_url">
                                                <PlayCircleFilledWhiteIcon
                                                    onClick={(PV) =>
                                                        window.open(
                                                            videoData.VideoURL
                                                        )
                                                    }
                                                />
                                            </p>
                                        </div>
                                    </Col>
                                );
                            })}
                        </Row>
                    </div>
                )}
            </Container>
        );
    }
}

const condition = (authUser) => !!authUser;

export default withAuthorization(condition)(Tranining);
